import Star from '@mui/icons-material/Star';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Button from '~c/components/base/button';
import Modal from '~c/components/base/modal';
import { QuickActionButton } from '~c/components/base/quick-action';
import Spacer, { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';
import TextField from '~c/components/base/text-field';

interface Props {
  className?: string;
}

const ModalDemo: React.FC<Props> = ({ className }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <QuickActionButton icon={Star} onClick={handleOpen}>
        Open modal
      </QuickActionButton>
      <Modal open={open} onClose={handleClose} title="Create new project">
        {/* place className here to style the modal container */}
        <div className={className}>
          <Text sz="body16">What are the project's details?</Text>
          <Spacer pb={spc.xs} />
          <TextField label="Project name" fullWidth />
          <Spacer pb={spc.xs} />
          <TextField label="Description" fullWidth />
          <Spacer pb={spc.m} />
          <Button className="button" fullWidth>
            Create
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default muiStyled(ModalDemo)(
  ({ theme }) => css`
    .button {
      .MuiButton-root {
        height: 56px;
      }
    }
  `
);
